import { useLocalStorage } from "usehooks-ts";
// import { useMutation, useQueryClient } from "react-query";
// import { authAxios as axios } from "shared-auth";
// import { AxiosError } from "axios";
// import {
//   GET_PROFILE_LAYOUT_SETTINGS,
//   useProfileLayoutSettings,
// } from "pages/Profile/hooks/useProfileLayoutSettings";

const PROFILE_HEAD_EXPANDED_LS_KEY = "PROFILE_HEAD_EXPANDED_LS_KEY";
const PROFILE_BODY_EXPANDED_LS_KEY = "PROFILE_BODY_EXPANDED_LS_KEY";

export function useLayoutConfiguration() {
  // const queryClient = useQueryClient();
  const [headExpanded, setHeadValue] = useLocalStorage(
    PROFILE_HEAD_EXPANDED_LS_KEY,
    false
  );
  const [bodyExpanded, setBodyValue] = useLocalStorage(
    PROFILE_BODY_EXPANDED_LS_KEY,
    false
  );

  // useProfileLayoutSettings();

  // const { mutate } = useMutation<
  //   unknown,
  //   AxiosError,
  //   { headExpanded: boolean; bodyExpanded: boolean }
  // >({
  //   mutationFn: (data) => {
  //     return axios.post("", data);
  //   },
  //   onSuccess: () => queryClient.invalidateQueries(GET_PROFILE_LAYOUT_SETTINGS),
  // });

  const expandHeadToggle = () => {
    setHeadValue((headValue) => !headValue);
    setBodyValue(false);
    // mutate({ headExpanded: true, bodyExpanded: false });
  };

  const expandBodyToggle = () => {
    setBodyValue((bodyValue) => !bodyValue);
    setHeadValue(false);
    // mutate({ headExpanded: true, bodyExpanded: false });
  };

  return {
    headExpanded,
    bodyExpanded,
    expandHeadToggle,
    expandBodyToggle,
  };
}
